// extracted by mini-css-extract-plugin
module.exports = {"Card":"card_Card__YhtRq","Horizontal":"card_Horizontal__xC1U6"};